import React from "react";
import EbDialog from "../ExecutionBlueprintLiveReview/_shared/EbDialog";
import "./InfoDialog.scss";

// ═════════════════════════════════════════════════════════════════════════════
// "How this review works" — the explainer behind the header icon on the coach's
// Execution Blueprint review screen.
//
// ⚠️ REBUILT ON `EbDialog` (2026-08-31). Props unchanged (`onClose` only).
//
// This and `LiveReviewInfoModal` were numerically IDENTICAL — 757px wide, 16px
// radius, 32px padding, the same shadow, the same teal button — yet maintained
// as two stylesheets under different class prefixes (`.rim-*` and `.lrim-*`),
// each borrowed from a different Strategy Canvas file. Both now use the shared
// shell plus one small stylesheet for the numbered list they have in common.
//
// One action and no cancel: this explains, it does not ask. The shell still
// renders a close button, because a dialog you can only leave through one
// specific button is one people feel trapped in.
// ═════════════════════════════════════════════════════════════════════════════

// Written as full sentences, punctuated — they read as instructions alongside
// the two prose paragraphs above them, not as a set of terse labels.
const STEPS = [
  "Open Review Mode and work down the blueprint, dimension by dimension.",
  "Accept a WIG, or mark it to discuss if it needs a conversation.",
  "Leave a comment on any WIG the CEO should read before you meet.",
  "Optionally, leave comments at the dimension level or on the blueprint overall.",
  "Complete the review and send it to the CEO once every WIG has a decision.",
];

const ReviewInfoModal = ({ onClose }) => (
  <EbDialog
    isOpen
    size="lg"
    // Neutral, not primary: nothing here is being confirmed, and a teal chip
    // would give an explainer the weight of a decision.
    tone="neutral"
    title="Start Execution Blueprint review"
    subtitle="The CEO has sent you their draft Execution Blueprint. Here's how to work through it."
    onClose={onClose}
    actions={[
      {
        // Present tense: "I understood" reports on some earlier occasion,
        // where this button is the coach acknowledging what they just read.
        label: "Got it",
        variant: "primary",
        onClick: onClose,
        autoFocus: true,
      },
    ]}
  >
    <p>
      You&apos;ve got two modes to work with: <strong>Blueprint Mode</strong>{" "}
      and <strong>Review Mode</strong>.
    </p>
    <p>
      Blueprint Mode shows the full blueprint laid out the way the CEO built it,
      and Review Mode is where you do the actual pass, WIG by WIG.
    </p>

    <ol className="info-steps">
      {STEPS.map((step) => (
        <li key={step}>{step}</li>
      ))}
    </ol>
  </EbDialog>
);

export default ReviewInfoModal;
